import React, { Component } from 'react';
import PlusSvg from './svg/PlusSvg';
import MinusSvg from './svg/MinusSvg';

export default class Counter extends Component {
    state = {
        count: 1,
    };

    handleDecrease = () => {
        this.setState((prevState) => ({
            count: prevState.count > 1 ? prevState.count - 1 : 1,
        }));
    };

    handleIncrease = () => {
        this.setState((prevState) => ({
            count: prevState.count + 1,
        }));
    };

    render() {
        return (
            <div className='flex items-center border-[2px] rounded-[8px] border-[#f0f0f0] size-fit'>
                <div className=' flex items-center justify-center '>
                    <button className='cursor-pointer p-[15px]' onClick={this.handleDecrease}><MinusSvg /></button>
                </div>
                <div className='flex justify-center items-center'>
                    <input
                        type="number"
                        value={this.state.count}
                        style={styles.input}
                        readOnly
                        className='w-full text-center'
                    />
                </div>


                <div className=' flex items-center justify-center '>
                    <button className='cursor-pointer p-[15px]' onClick={this.handleIncrease}><PlusSvg /></button>

                </div>
            </div>
        );
    }
}

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #000',
        width: 'fit-content',
    },
    btn: {
        width: '30px',
        height: '30px',
        cursor: 'pointer',
        border: 'none',
        background: '#f0f0f0',
        fontSize: '18px',

    },
    input: {
        width: '40px',
        height: '30px',
        textAlign: 'center',
        border: 'none',
        // borderLeft: '1px solid #000',
        // borderRight: '1px solid #000',
        background: '#fff',
    },
};
